import React, { useState } from 'react'
import Modal from '@mui/material/Modal'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import Button from '@mui/material/Button'
import './Modal.scss'

const paperStyle: React.CSSProperties = {
  position: 'absolute',
  backgroundColor: '#fff',
  boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
  padding: '16px',
  width: '80%',
  maxWidth: 900,
  maxHeight: '80vh'
}

function getModalStyle () {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  }
}

interface Props {
  isOpen: boolean
  onClose: () => void
  title?: string
  isDelete?: boolean
  children?: React.ReactNode
  darkBackdrop?: boolean
  disableCloseButton?: boolean
  titleClassName?: string
}

const ModalComponent: React.FC<Props> = (props) => {
  const [open, setOpen] = useState(props.isOpen)
  const handleClose = () => {
    setOpen(false)
    props.onClose()
  }
  const body = (
    <div style={{ ...getModalStyle(), ...paperStyle }}>
     <div className={'modal-close'}>{!props.disableCloseButton && <CloseRoundedIcon className={'close-icon'} onClick={handleClose} />}</div> 
      <div>
      <h2 id="modal-title" className={props.titleClassName}>{props.title}</h2>
      
      <div id="modal-description">{props.children}</div>
      {props.isDelete && (
        <div className={'modal-footer'}>
          <Button variant="contained" id={'close-modal'} onClick={handleClose}>
            {'OK'}
          </Button>
        </div>
      )}
    </div>
    </div>
  )
  return (
    <Modal
      open={open}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      style={{ alignItems: 'center', justifyContent: 'center' }}
      slotProps={{ backdrop: props.darkBackdrop ? { className: 'modal-backdrop-dark' } : undefined }}
    >
      {body}
    </Modal>
  )
}

export default ModalComponent
